import axiosClient from "api/apiClient";

interface IOptions {
    id?: string;
    sort?: string;
    search?: string;
}

interface IOptionsWorkPlan {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    student_id: string;
}

export const APIGetStudent = (options: IOptions) => {
    let sort = "";
    let search = "";
    if (options.hasOwnProperty("sort")) {
        sort = "&sort=" + options.sort;
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.sort;
    }
    return axiosClient.get(`/students/${options.id}?${search}${sort}`);
};

export const APIUpdateStudent = (id: string, data: object) => {
    return axiosClient.put(`/students/${id}`, data);
};

export const APIPostStudent = (data: object) => {
    return axiosClient.post(`/students`, data);
};

export const APICheckStudents = () => {
    return axiosClient.get('/students/check');
}

export const APIGetStudentWorkPlans = (options: IOptionsWorkPlan) => {
    let sort = "";
    let search = "";
    let studentId = "";
    if (options.hasOwnProperty("sort")) {
        if (options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("student_id")) {
        if (options.student_id !== undefined) {
            studentId = "&student_id=" + options.student_id;
        }
    }

    return axiosClient.post(`/work-plans/students/tests${options.page}${search}${sort}${studentId}`);
};
